<template>
	<div class="relative grid grid-cols-1 lg:grid-cols-[48px_1fr] gap-2">
		<ul class="flex lg:flex-col gap-2 order-2 lg:!order-1 !mx-4 lg:!mx-0">
			<li v-for="(image, index) of productImages">
				<button type="button" :class="['cursor-pointer', selectedScrollSnap === index ? 'ring-2 ring-black' : '']">
					<figure class="w-12 h-[60px]" @click="() => goToIndex(index)">
						<video v-if="image.mimeType.includes('video')" :src="image.src" autoplay loop muted playsinline />
						<img
							v-else
							:src="image.src"
							:alt="`${title} ${index}`"
							class="w-full object-contain"
							loading="eager"
							rel="preload"
						/>
					</figure>
				</button>
			</li>
		</ul>
		<div ref="emblaRef" class="w-full overflow-hidden order-1 lg:!order-2">
			<ul class="backface-hidden flex touch-pan-y">
				<li
					v-for="(image, index) of productImages"
					:class="[
						'grow-0 shrink-0 basis-full min-w-0',
						maxShow === 4 && 'basis-6/12 sm:basis-1/2 lg:basis-4/12 xl:basis-3/12',
						maxShow === 3 && 'sm:basis-1/2 lg:basis-4/12',
						maxShow === 2 && 'sm:basis-1/2',
					]"
				>
					<figure>
						<video v-if="image.mimeType.includes('video')" :src="image.src" autoplay loop muted playsinline />
						<img
							v-else
							:src="image.src"
							:alt="`${title} ${index}`"
							class="w-full object-contain"
							loading="eager"
							rel="preload"
						/>
					</figure>
				</li>
			</ul>
		</div>
	</div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue'
import { storeToRefs } from 'pinia'
import emblaCarouselVue from 'embla-carousel-vue'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'

import { useProductStore } from '@stores'

const props = defineProps({
	images: {
		type: Array,
		required: false,
		default: () => [],
	},
	title: {
		type: String,
		required: true,
	},
	useStore: {
		type: Boolean,
		default: false,
	},
	maxShow: {
		type: Number,
		default: 1,
	},
})

const store = useProductStore()
const { variantImages, selectedVariant } = storeToRefs(store)

const [emblaRef, emblaApi] = emblaCarouselVue({ loop: true }, [WheelGesturesPlugin()])
const selectedScrollSnap = ref(0)

onMounted(async () => {
	if (emblaApi.value) {
		emblaApi.value.on('scroll', () => {
			selectedScrollSnap.value = emblaApi.value.selectedScrollSnap()
		})
	}
	if (variantImages.value) {
		// preload variant images
		const promises = variantImages.value.map((image) => {
			return new Promise((resolve) => {
				const img = new Image()
				img.src = image.src
				img.onload = resolve
			})
		})

		await Promise.all(promises)
	}
})

const productImages = computed(() => (props.useStore ? selectedVariant.value?.images : props.images) ?? [])

const goToIndex = (index) => emblaApi.value.scrollTo(index)
</script>
